const ErrorPage: React.FC = () => <div>Error Page</div>;

export default ErrorPage;
